import React from 'react';
import Toast, { ToastProps } from './Toast';

interface ToastContainerProps {
  toasts: ToastProps[];
  onClose: (id: string) => void;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ toasts, onClose }) => {
  return (
    <div
      className="pointer-events-none fixed inset-x-4 top-20 z-[120] flex flex-col gap-2 sm:inset-x-auto sm:right-4 sm:top-20 sm:w-[420px] sm:items-end"
      aria-live="polite"
      role="status"
    >
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          {...toast}
          onClose={onClose}
        />
      ))}
    </div>
  );
};

export default ToastContainer;
